<template>
  <div :class="$style.base">
    <BaseModal
      v-if="showUnbookableModal"
      :message="$t('availabilities.unavailable_reschedule')"
      unclosable
      testId="error-reschedule"
    />
    <Steps />
  </div>
</template>

<script setup lang="ts">
import axios from '@/axios';
import BaseModal from '@/components/BaseModal.vue';
import { useBookingStore } from '@/stores/booking';
import widgetSettings from '@/widget-settings';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Steps from './steps/index.vue';
import { useCompanyStore } from './stores/company';

if (widgetSettings.locationId) {
  const bookingStore = useBookingStore();
  bookingStore.locationId = widgetSettings.locationId;
}

const showUnbookableModal = ref(false);
if (widgetSettings.bookingId) {
  const { locationId } = useBookingStore();

  axios
    .get(
      `/locations/${locationId}/bookings/${widgetSettings.bookingId}/reschedule_validations`
    )
    .catch(() => {
      // Appointment cannot be rescheduled
      showUnbookableModal.value = true;
    });
}

const preloaderEl = document.querySelector('#preloader');
if (preloaderEl) {
  preloaderEl.remove();
}

// Storing user details in localstorage is done via the loader,
// because Safari can't store them if they're inside an iframe
window.addEventListener('message', (e) => {
  if (e.data?.userDetails) {
    localStorage.setItem('bookingUserDetails', e.data.userDetails);
  }
});

const i18n = useI18n();
const { settings } = useCompanyStore();
if (settings.currency) {
  i18n.availableLocales.forEach((locale) => {
    i18n.setNumberFormat(locale, {
      currency: {
        style: 'currency',
        currency: settings.currency
      }
    });
  });
}
</script>

<style lang="scss" module>
.base {
  height: 100%;
}
</style>
